"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyProjectActions;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
// New handlers imports
const updateHandlers_1 = require("./updateHandlers");
const handleAutofillProject_1 = __importDefault(require("./updateHandlers/handleAutofillProject"));
const either_1 = require("../../types/either");
const handleRemoveLayersFromPrintable_1 = __importDefault(require("./updateHandlers/handleRemoveLayersFromPrintable"));
const handleToggleForceClientSideTextPrintable_1 = __importDefault(require("./updateHandlers/handleToggleForceClientSideTextPrintable"));
const handleSwapHalfSpreads_1 = __importDefault(require("./updateHandlers/handleSwapHalfSpreads"));
const handleUpdatePrintableLayer_1 = __importDefault(require("./updatePrintableLayer/handleUpdatePrintableLayer"));
const handleDeleteGalleryImage_1 = __importDefault(require("./updateHandlers/handleDeleteGalleryImage"));
const handleUpdateContactGroupId_1 = __importDefault(require("./updateHandlers/handleUpdateContactGroupId"));
const handleUpdateEnvelopeReturnAddress_1 = __importDefault(require("./updateHandlers/handleUpdateEnvelopeReturnAddress"));
const handleDuplicateLayer_1 = __importDefault(require("./updateHandlers/handleDuplicateLayer"));
function applyProjectActions(_a) {
  return __awaiter(this, arguments, void 0, function (_ref) {
    let {
      project,
      actions,
      dependencies
    } = _ref;
    return function* () {
      let updatedProject = project;
      let updatedEntities = [];
      for (const action of actions) {
        if (updatedProject && action.currentProjectVersion && action.currentProjectVersion !== updatedProject.version) {
          // We don't want to necissarily fail on this contition yet. We want to report and investigate how often this is happening - EN-8875
          const error = new Error(`The action, ${action.type}, was taken on project version ${action.currentProjectVersion}, but the given project is at version ${updatedProject.version}.`);
          if (dependencies.reportError) {
            dependencies.reportError(error, {
              userId: updatedProject.createdBy,
              projectId: updatedProject.id,
              projectVersion: updatedProject.version,
              projectActionType: action.type,
              projectActionTimestamp: action.timestamp,
              projectActionVersion: action.currentProjectVersion
            });
          } else {
            console.error(error);
          }
        }
        const updateResult = yield applyProjectAction({
          project: updatedProject,
          action,
          dependencies
        });
        if (updateResult.isLeft()) {
          return (0, either_1.left)(updateResult.value);
        }
        updatedProject = (0, lodash_clonedeep_1.default)(updateResult.value.updatedProject);
        updatedEntities = [...updatedEntities, ...updateResult.value.updatedEntities];
      }
      if (!updatedProject) {
        throw new Error('No updated project found, something has gone terribly wrong...');
      }
      const updateProjectReturn = {
        updatedProject: updatedProject,
        updatedEntities
      };
      return (0, either_1.right)(updateProjectReturn);
    }();
  });
}
const applyProjectAction = _a => __awaiter(void 0, [_a], void 0, function (_ref2) {
  let {
    project,
    action,
    dependencies
  } = _ref2;
  return function* () {
    if (!project) {
      if (action.type === 'CREATE_PROJECT') {
        return (0, updateHandlers_1.handleCreateProject)(action, dependencies);
      } else {
        return (0, either_1.left)(new Error(`Project required for action ${action.type}`));
      }
    }
    switch (action.type) {
      case 'ADD_INTERIOR_PRINTABLES_TO_BOOK_PROJECT':
        return (0, updateHandlers_1.handleAddInteriorPrintablesToBookProject)(project, action, dependencies);
      case 'REMOVE_PRINTABLES_FROM_PRINTABLE_GROUP':
        return (0, updateHandlers_1.handleRemovePrintableFromPrintableGroup)(project, action, dependencies);
      case 'REMOVE_ALL_IMAGES':
        return (0, updateHandlers_1.handleRemoveAllImages)(project, action);
      case 'REMOVE_LAYERS_FROM_PRINTABLE':
        return (0, handleRemoveLayersFromPrintable_1.default)(project, action);
      case 'UPDATE_PRINTABLE_DESIGN':
        return (0, updateHandlers_1.handleUpdatePrintableDesign)(project, action, dependencies);
      case 'UPDATE_PROJECT_PRODUCT_OPTIONS':
        return (0, updateHandlers_1.handleUpdateProjectProductOptions)(project, action, dependencies);
      case 'ACK_EMPTY_PRINTABLE':
        return (0, updateHandlers_1.handleAckEmptyPrintable)(project, action);
      case 'SWAP_PRINTABLE_LAYER_USER_DATA':
        return (0, updateHandlers_1.handleSwapPrintableLayerUserData)(project, action);
      case 'UPDATE_IS_DESIGN_SERVICES_PROJECT':
        return (0, updateHandlers_1.handleIsDesignServicesProject)(project, action);
      case 'UPDATE_PRINTABLE_GROUP_QUANTITY':
        return (0, updateHandlers_1.handleUpdatePrintableGroupQuantity)(project, action);
      case 'UPDATE_PRINTABLE_GROUP_WORKSPACE_ROTATION':
        return (0, updateHandlers_1.handleUpdatePrintableGroupWorkspaceRotation)(project, action);
      case 'UPDATE_PRINTABLE_LAYER_USER_DATA':
        return (0, updateHandlers_1.handleUpdatePrintableLayerUserData)(project, action);
      case 'UPDATE_PROJECT_NAME':
        return (0, updateHandlers_1.handleUpdateProjectName)(project, action);
      case 'UPDATE_SELECTED_GALLERY_ID':
        return (0, updateHandlers_1.handleUpdateSelectedGalleryId)(project, action);
      case 'UPDATE_PROJECT_STATUS':
        return (0, updateHandlers_1.handleUpdateProjectStatus)(project, action);
      case 'UPDATE_PROJECT_MARKED_FOR_DELETION':
        return (0, updateHandlers_1.handleUpdateProjectMarkedForDeletion)(project, action);
      case 'UPDATE_PRINTABLE_GROUP_ORDER':
        return (0, updateHandlers_1.handleUpdatePrintableGroupOrder)(project, action);
      case 'UPDATE_PRINTABLE_LAYER_POSITION':
        return (0, updateHandlers_1.handleUpdatePrintableLayerPosition)(project, action);
      case 'UPDATE_PRINTABLE_LAYER':
        return (0, handleUpdatePrintableLayer_1.default)(project, action);
      case 'MARK_FOR_DELETION':
        return (0, updateHandlers_1.handleMarkForDeletion)(project, action);
      case 'AUTOFILL_PROJECT':
        return (0, handleAutofillProject_1.default)(project, action, dependencies.getTemplate, dependencies.getART);
      case 'VALIDATE_PRODUCT_OPTIONS':
        return (0, updateHandlers_1.handleValidateProductOptions)(project, action, dependencies);
      case 'ADD_EDITABLE_TEXT_LAYER':
        return (0, updateHandlers_1.handleAddEditableTextLayerToPrintable)(project, action);
      case 'TOGGLE_FORCE_CLIENT_SIDE_TEXT_PRINTABLE':
        return (0, handleToggleForceClientSideTextPrintable_1.default)(project, action);
      case 'SWAP_HALF_SPREADS':
        return (0, handleSwapHalfSpreads_1.default)(project, action);
      case 'UPDATE_DESIGN_FOR_PRINTABLES':
        return (0, updateHandlers_1.handleUpdateDesignForPrintables)(project, action, dependencies);
      case 'DELETE_GALLERY_IMAGE':
        return (0, handleDeleteGalleryImage_1.default)(project, action);
      case 'UPDATE_PRINTABLE_LAYER_Z_INDEX':
        return (0, updateHandlers_1.handleUpdatePrintableLayerZIndex)(project, action);
      case 'UPDATE_CONTACT_GROUP_ID':
        return (0, handleUpdateContactGroupId_1.default)(project, action);
      case 'UPDATE_ENVELOPE_RETURN_ADDRESS':
        return (0, handleUpdateEnvelopeReturnAddress_1.default)(project, action);
      case 'UPDATE_PROJECT_QUANTITY':
        return (0, updateHandlers_1.handleUpdateProjectQuantity)(project, action);
      case 'DUPLICATE_LAYER':
        return (0, handleDuplicateLayer_1.default)(project, action);
      default:
        return (0, either_1.left)(new Error(`Action type ${action.type} not supported.`));
    }
  }();
});